import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";
const dash = new AxiosInterceptor();

export default {
  get() {
    return dash.get("/dashboard");
  },
  getRenewal() {
    return dash.get("/dashboard/today-renewal");
  },
  getBirthday() {
    return dash.get("/dashboard/today-birthday");
  },
  getChartOrder(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return dash.get("/dashboard/chart-orders?" + qstr);
  },
  getNotification() {
    return dash.get("/dashboard/today-notification");
  },
  getNotificationPage(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return dash.get("/dashboard/latest-notification?" + qstr);
  },
  getAllTypeNoti() {
    return dash.get("/dashboard/types-notification");
  }
};
